import React from 'react';

export const LoginForm = props => (
  <form className="login-form">
    {props.children({
      usernameField: (
        <div className="form-group">
          <label htmlFor="_username">Username</label>
          <input
            className="form-control"
            id="_username"
            type="text"
            name="_username"
            required={true}
            autoFocus={true}
            value={props.username}
            onChange={props.onChangeUsername}
          />
        </div>
      ),
      passwordField: (
        <div className="form-group">
          <label htmlFor="_password">Password</label>
          <input
            className="form-control"
            id="_password"
            type="password"
            name="_password"
            required={true}
            value={props.password}
            onChange={props.onChangePassword}
          />
        </div>
      ),
      loginButton: (
        <button
          className="btn btn-lg btn-primary"
          disabled={props.pending || !props.username || !props.password}
          onClick={props.onLogin}
          type="submit"
        >
          Sign In
        </button>
      ),
      ssoButton: props.onSso && (
        <button
          className="btn btn-lg btn-outline-primary"
          disabled={props.pending}
          onClick={() => props.onSso()}
          type="button"
        >
          Enterprise Single Sign-on
        </button>
      ),
    })}
  </form>
);
